import { Navigate, useLocation } from 'react-router-dom';

/**
 * The suppliers' catalogs moved to "Katalog sprzętu → Katalogi dostawców" (owner 2026-10-21 00:08). Old links
 * (`/finanse/cenniki/katalogi-dostawcow?dostawca=…`, bookmarks) land on the new place, on the same supplier.
 */
export function SupplierPricesPage() {
  const { search } = useLocation();
  const supplier = new URLSearchParams(search).get('dostawca');
  return <Navigate to={supplier ? `/katalog/dostawcy/${encodeURIComponent(supplier)}` : '/katalog/dostawcy'} replace />;
}
